export const TOGGLE_EDIT_USER_MODAL = 'TOGGLE_EDIT_USER_MODAL'
export const toggleEditUserModal = (show) => ({
  type: TOGGLE_EDIT_USER_MODAL,
  show,
})
